<template>
  <div>
    <a v-on:click.prevent="showModal = true" class="delete" href="#">{{ $t("plan.deleteAdmin.delete") }}</a>
      <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('plan.deleteAdmin.modal.header', {name: adminName})" @close="showModal = false">
        <p class="modal-text" v-html="$t('plan.deleteAdmin.modal.text')"></p>
        <a v-on:click.prevent="deleteAdmin" class="button" href="#">{{ $t("plan.deleteAdmin.modal.button") }}</a>
      </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { planService } from '@/services/plan.service'

export default {
  props: ['adminName', 'appUserId', 'planId'],
  name: 'DeleteAdmin',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deleteAdmin: function () {
      planService.deleteOwner(this.planId, this.appUserId).then(() => {
        this.showModal = false
        this.$router.go(0)
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
a.delete {
  display: block;
  width: 16px;
  height: 20px;
  margin-left: 30px;
  background: url('../../assets/icons/trash-can.png') no-repeat;
  text-indent: -9999px;
  white-space: nowrap;
}
.modal-text {
  font-weight: bold;
}
</style>
